import {
  FETCH_PRODUCTION_ORDERS,
  FETCH_PRODUCTION_ORDERS_SUCCESS,
  FETCH_PRODUCTION_ORDERS_FAIL,
  FETCH_PRODUCTION_TASKS,
  FETCH_PRODUCTION_TASKS_SUCCESS,
  FETCH_PRODUCTION_TASKS_FAIL,
  UPDATE_ORDER_STATUS,
  UPDATE_ORDER_STATUS_SUCCESS,
  UPDATE_ORDER_STATUS_FAIL,
  BULK_UPDATE_ORDERS,
  BULK_UPDATE_ORDERS_SUCCESS,
  BULK_UPDATE_ORDERS_FAIL,
  CLEAR_PRODUCTION_CACHE,
  SET_PRODUCTION_FILTER,
} from "./actionTypes"

// Fetch Orders
export const fetchProductionOrders = (forceRefresh = false) => ({
  type: FETCH_PRODUCTION_ORDERS,
  payload: { forceRefresh },
})

export const fetchProductionOrdersSuccess = (orders) => ({
  type: FETCH_PRODUCTION_ORDERS_SUCCESS,
  payload: orders,
})

export const fetchProductionOrdersFail = (error) => ({
  type: FETCH_PRODUCTION_ORDERS_FAIL,
  payload: error,
})

// Fetch Tasks
export const fetchProductionTasks = (forceRefresh = false) => ({
  type: FETCH_PRODUCTION_TASKS,
  payload: { forceRefresh },
})

export const fetchProductionTasksSuccess = (tasks) => ({
  type: FETCH_PRODUCTION_TASKS_SUCCESS,
  payload: tasks,
})

export const fetchProductionTasksFail = (error) => ({
  type: FETCH_PRODUCTION_TASKS_FAIL,
  payload: error,
})

// Update Order Status
export const updateOrderStatus = (orderId, status, extraData = {}) => ({
  type: UPDATE_ORDER_STATUS,
  payload: { orderId, status, extraData },
})

export const updateOrderStatusSuccess = (order) => ({
  type: UPDATE_ORDER_STATUS_SUCCESS,
  payload: order,
})

export const updateOrderStatusFail = (error) => ({
  type: UPDATE_ORDER_STATUS_FAIL,
  payload: error,
})

// Bulk Update Orders
export const bulkUpdateOrders = (orderIds, status) => ({
  type: BULK_UPDATE_ORDERS,
  payload: { orderIds, status },
})

export const bulkUpdateOrdersSuccess = (orders) => ({
  type: BULK_UPDATE_ORDERS_SUCCESS,
  payload: orders,
})

export const bulkUpdateOrdersFail = (error) => ({
  type: BULK_UPDATE_ORDERS_FAIL,
  payload: error,
})

// Clear cache
export const clearProductionCache = () => ({
  type: CLEAR_PRODUCTION_CACHE,
})

// Set filter
export const setProductionFilter = (filter) => ({
  type: SET_PRODUCTION_FILTER,
  payload: filter,
})
